import Swiper from "swiper/bundle";

const PartsSlider = () => {
  const partsSliders = [...document.querySelectorAll(".parts-slider__slider")];

    if (partsSliders.length > 0) {
    partsSliders.forEach((partsSlider) => {

      const partsCarousel = new Swiper(partsSlider, {
        slidesPerView: "auto",
        spaceBetween: 16,
        loop: true,
        centeredSlides: true,
        autoplay: {
          delay: 0, 
          disableOnInteraction: false, 
        },
        speed: 4000,
        breakpoints: {
          768: {
            spaceBetween: 20,
          },
          1024: {
            spaceBetween: 24,
          },
          1441: {
            spaceBetween: 32,
          },
        },
      });
    });
  }
}

export default PartsSlider;



